import { TermsAndPrivacyUpdate } from './termsAndPrivacyUpdate.jsx';

const props = [ window.WB.locale ];

export const TermsAndPrivacyUpdateDirective = reactDirective => reactDirective(TermsAndPrivacyUpdate, props);
TermsAndPrivacyUpdateDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('termsAndPrivacyUpdate', TermsAndPrivacyUpdateDirective);